import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useSetLoginData } from '../../../../graphql/client/useSetLoginData';
import { AuthSignedInUserResponseProps } from '../../../../types/user';

export const useLoginDataSetup = () => {
  const location = useLocation();
  const { setLoginData } = useSetLoginData();
  const hasLoginDataBeenSet = useRef(false);

  const loginData = location.state?.loginData as
    | AuthSignedInUserResponseProps
    | undefined;

  useEffect(() => {
    if (loginData && !hasLoginDataBeenSet.current) {
      setLoginData(loginData);
      hasLoginDataBeenSet.current = true;
    }
  }, []);
};
